<template lang="pug">
.intro-form
    .info-form-legend(v-html="$filters.sanitize(getString(config.description_langkey, { ns: 'configurable', defaultValue: config.description }))")
    .form-input-wrapper
        .intro-form-input-container(v-if="shownFields.name && shownFields.name.show")
            label.intro-form-label {{ getString(shownFields.name.label_langkey, { ns: 'configurable', defaultValue: shownFields.name.label }) }}
                .intro-form-input
                    input(v-model="record.name"
                        type="text", maxlength="60"
                        :placeholder="getString(shownFields.name.placeholder_langkey, { ns: 'configurable', defaultValue: shownFields.name.placeholder })")
        .intro-form-input-container(v-if="shownFields.email && shownFields.email.show")
            label.intro-form-label {{ getString(shownFields.email.label_langkey, { ns: 'configurable', defaultValue: shownFields.email.label }) }}
                span.incorrect-email(v-if="!isEmailCorrect") ({{ getString('screen.prechat_survey.incorrect_email', 'Email incorrect') }})
                .intro-form-input
                    input(v-model="record.email"
                        type="email"
                        :placeholder="getString(shownFields.email.placeholder_langkey, { ns: 'configurable', defaultValue: shownFields.email.placeholder })")

        .intro-form-input-container(v-if="shownFields.country && shownFields.country.show")
            label.intro-form-label {{ getString(shownFields.country.label_langkey, { ns: 'configurable', defaultValue: shownFields.country.label })  }}
                .intro-form-input
                    aiq-select(v-model="record.country"
                            filterable
                            :placeholder="getString(shownFields.country.placeholder_langkey, { ns: 'configurable', defaultValue: shownFields.country.placeholder })"
                            size="small")
                        aiq-option(v-for="country in shownFields.country.select_options"
                                :key="country"
                                :label="country"
                            :value="country")
    .button-wrapper
        aiq-button.intro-form_send-email(@click="submitForm", :disabled="!isValid" type="primary") {{ getString('screen.prechat_survey.start_chat', 'Start Chat') }}
    .intro-form-actions
        .intro-form-copyright {{ getString('screen.chat.copyright', 'Powered by Agent IQ') }}
</template>


<script>
import get from 'lodash/get';
import i18n from '../../mixins/i18n';

export default {
  name: 'prechat-component',
  mixins: [i18n],
  props: {
    payload: {
      type: Object,
      default: () => ({ content: '{ "input_fields": {} }' }),
    },
  },
  computed: {
    config() {
      return JSON.parse(get(this.payload, 'content', '{ "input_fields": {} }'));
    },
    isEmailCorrect() {
      if (!this.record.email) {
        return true;
      }

      return get(this, 'record.email.length') === 0 ? true : this.checkEmail();
    },
    requiredFieldsFilled() {
      for (const fieldName of this.requiredFields) {
        if (!this.record[fieldName]) {
          return false;
        }
      }

      return true;
    },
    isValid() {
      if (!get(this, 'shownFields.email.show', false)) {
        return this.requiredFieldsFilled;
      }

      return this.isEmailCorrect && this.requiredFieldsFilled;
    },
  },
  watch: {
    config() {
      this.initialize();
    },
  },

  data() {
    return {
      record: {},
      requiredFields: [],
      shownFields: {},
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      const inputFields = this.config.input_fields;
      this.record = Object.keys(inputFields).reduce((acc, fieldName) => {
        acc[fieldName] = '';
        this.shownFields[fieldName] = inputFields[fieldName];

        if (inputFields[fieldName].is_required) {
          this.requiredFields.push(fieldName);
        }
        return acc;
      }, {});
    },

    submitForm() {
      this.$emit('submit', { ...this.record });
    },

    checkEmail() {
      // eslint-disable-next-line
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.record.email);
    },
  },
};
</script>

<style lang="scss">
@import "../../aiq-theme/aiq-variables.scss";

label {
  cursor: pointer;
}
input {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.incorrect-email {
    margin-left: 5px;
    color: red;
}

.intro-form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 15px 15px;
    background: #fff;
    z-index: 10;
    box-sizing: border-box;
}

.info-form-legend {
    padding: 15px 0 20px;
    color: #67737F;
    font-size: 14px;
    line-height: 17px;
}
.intro-form-input-container {
    margin-bottom: 20px;
}
.intro-form-label {
  display: block;
  color: #28292c;
  font-size: 14px;
  line-height: 19px;
}
.intro-form-input {
    display: flex;
    align-items: center;
    height: 42px;
    margin-top: 10px;
    border-radius: 4px;
    transition: box-shadow .15s;

    input {
        width: 100%;
        height: 100%;
        padding: 0 10px;
        font-size: 15px;
        line-height: 18px;
        border: 1px solid;
        border-color: #e4e8ee;
        border-radius: 4px;
        outline: 0;
        background-color: transparent;
        overflow: hidden;
        box-sizing: border-box;
        color: #28292c;

        ::placeholder {
            color: #6b6d70;
        }
        &::-webkit-input-placeholder {
            color: #6b6d70;
        }
        &::-moz-placeholder {
            color: #6b6d70;
            opacity: 1;
        }
        &:-ms-input-placeholder {
            color: #6b6d70;
            opacity: 1;
        }
        &:-moz-placeholder {
            color: #6b6d70;
        }
    }
    &.required {
        box-shadow: inset 0 0 5px 0 #ff0000;
    }

    .el-select {
        width: 100%;
    }

    .el-select-dropdown__item {
        color: #67737F;
    }

    .el-input__inner {
        color: #67737F;
    }

    .el-input--small .el-input__inner, .el-select.el-select--small, .el-input.el-input--small {
        height: 100%;
    }
}
.intro-form-hours {
    color: #67737F;
    font-size: 12px;
}
.intro-form-actions {
    margin-top: auto;
    padding-top: 10px;
}
.button-wrapper {
    text-align: center;
}
.intro-form_send-email.el-button {
    min-width: 95px;
    width: 75%;
    height: 36px;
    padding: 0;
    margin-top: 40px;
    margin-bottom: 8px;
    color: #fff;
    font-size: 14px;
    line-height: 36px;
    border: 0;
    border-radius: 4px;

    &[disabled] {
        font-size: 14px;
    }
}

.close-form {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 10px;
    height: 10px;
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
}

.intro-form-copyright {
    color: $aiq-webchat-ligher-text;
    font-size: 10px;
    text-align: right;
    clear: both;
}

@media (max-width: 449px)
and (orientation: portrait) {
    .info-form-header {
        border-radius: 0;
    }
}
@media (min-width: 320px)
and (max-width: 767px)
and (orientation: landscape) {
    .info-form-header {
        border-radius: 0;
    }
}
</style>
